import React, { createContext, useEffect, useState } from 'react';
import { Get_Api } from "../ApiUrls";

export const CategoryContext = createContext();

export const CategoryProvider = ({ children }) => {
    const [selectedCategory, setSelectedCategory] = useState('');
    const [allCategories, setAllCategories] = useState([]);
    const [isUploading, setIsUploading] = useState(false);

    const fetchCategories = async () => {
        try {
            setIsUploading(true);
            const response = await Get_Api(`api/admin/GetAllCategorys`);
            setAllCategories(response?.data || []);
            setIsUploading(false);
        } catch (error) {
            setIsUploading(false);
            console.error("Error fetching categories:", error);
        }
    };

    useEffect(() => {
        fetchCategories();
    }, []);

    return (
        <CategoryContext.Provider value={{ selectedCategory, setSelectedCategory, allCategories }}>
            {children}
        </CategoryContext.Provider>
    );
};
